import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = { opacity: "0.5" }
const _hoisted_3 = ["fill"]


const __default__ = {};

interface IProps {
  fill?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IconCustomArrownUp',
  props: {
    fill: { default: "#ffffff" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M5.00003 2.14986C5.17925 2.14986 5.35845 2.21829 5.49508 2.35486L9.79486 6.65468C10.0684 6.92821 10.0684 7.37167 9.79486 7.64509C9.52145 7.9185 9.07807 7.9185 8.80452 7.64508L5.00003 3.84037L1.19551 7.64495C0.921988 7.91836 0.478652 7.91836 0.205262 7.64495C-0.0683918 7.37154 -0.0683917 6.92807 0.205262 6.65455L4.50497 2.35473C4.64168 2.21814 4.82087 2.14986 5.00003 2.14986Z",
        fill: _ctx.fill
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})